import { useRecordTypes } from '../useRecordTypes';
export var useCrossTenantCheck = function () {
    var recordTypes = useRecordTypes().recordTypes;
    var isCrossTenant = function (id) {
        var recordType = recordTypes.find(function (_a) {
            var savedId = _a.id;
            return id === savedId;
        });
        return Boolean(recordType === null || recordType === void 0 ? void 0 : recordType.crossTenantQueriesEnabled);
    };
    return {
        isCrossTenant: isCrossTenant
    };
};
